import { useAudioPlayer } from './useAudioPlayer';
import { useCallback, useState } from 'react';

export const useTry = () => {
  const { load, reset, ...rest } = useAudioPlayer();

  const [value, setValue] = useState<any>();

  const onLoad = useCallback((value: string, tryValue: any) => {
    setValue(tryValue);
    load(value);
  }, [load]);

  const onReset = useCallback(() => {
    setValue(undefined);
    reset();
  }, [reset]);

  return {
    value,
    load: onLoad,
    reset: onReset,
    ...rest,
  };
};
